import { onMounted, type Ref } from 'vue'
import useSnackbar from 'src/composables/useSnackbar'
import useUserStorage from 'src/composables/useUserStorage'
import { getSnackbarTownSelected } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.constants'

export default function useSideMenuTownSnackbar(town: Ref<string>, townSelectUrl: Ref<string>) {
  const snackbar = useSnackbar()
  const { userStorage } = useUserStorage()

  function showSelectedTownSnackbar() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return
    }

    const selectedTown = userStorage.get('selectedTown')
    const isSelectedTownFromTownPage = document.referrer === window.location.origin + townSelectUrl.value

    if (!selectedTown || !isSelectedTownFromTownPage) {
      return
    }

    const snackbarTownSelected = getSnackbarTownSelected()

    snackbar.show({
      text: `${snackbarTownSelected.message}${town.value}`,
      action: {
        btnText: snackbarTownSelected.actionText,
        onClick: () => {
          window.location.href = townSelectUrl.value
        },
      },
    })
  }

  onMounted(showSelectedTownSnackbar)

  return {
    showSelectedTownSnackbar,
  }
}
